$(document).ready(function () {
  // obecne
  var bodyWidth = window.innerWidth;

  // události při resize okna
  $(window).on('resize', function () {
    // osetreni, zda se velikost zmenila
    if (bodyWidth !== window.innerWidth) {
      // nastavíme novou šířku
      bodyWidth = window.innerWidth;
      // zresetuj menu
      resetMenu();
      // nastavíme orderMenu v objednávce pojištění
      orderMenu();
    }
  });

  // mobilní menu
  function switchMenu() {
    // označíme zda je menu zavřeno či nikoliv
    if ($('.nav-switcher').hasClass('is-open')) {
      $('.nav-switcher, .nav').removeClass('is-open');
      $('body').removeClass('is-unscrollable');
    } else {
      $('.nav-switcher, .nav').addClass('is-open');
      $('body').addClass('is-unscrollable');
    }
  }
  // při změně rozlišení resetujeme menu
  function resetMenu() {
    $('.nav-switcher, .nav, .summary').removeClass('is-open');
    $('body').removeClass('is-unscrollable');
  }
  // spouštěč
  $('.nav-switcher').on('click', function () {
    switchMenu();
  });

  // události při načtení stránky
  $(window).on('load', function () {
    // AOS fix pro první načítání
    AOS.refresh();
    orderMenu();

    // preloader
    if ($('.preloader').length) {
      document.cookie = 'beenHere=1';
      document.querySelector('.preloader').classList.add('is-loaded');
    }
  });

  // události při scroolování
  $(window).on('scroll', function () {
    customSelectAbove();
  });

  // objednávka pojištění pozice přehledu pojištění v menu
  function orderMenu() {
    let orderMenuOverview = document.querySelectorAll('.js-insure-overview');
    for (let i = 0; i < orderMenuOverview.length; i++) {
      if (
        innerHeight + 32 <
        orderMenuOverview[i].getBoundingClientRect().height +
          orderMenuOverview[i].parentNode.getBoundingClientRect().top
      ) {
        orderMenuOverview[i].style.top =
          orderMenuOverview[i].parentNode.getBoundingClientRect().top -
          orderMenuOverview[i].getBoundingClientRect().height +
          52 +
          'px';
      } else {
        orderMenuOverview[i].style.top =
          orderMenuOverview[i].parentNode.getBoundingClientRect().top -
          16 +
          'px';
      }
    }
  }

  // přidání aktivní třídy po kliknutí na položku "insure-item"
  if ($('.insure-item').length) {
    insureItem();
    $('.insure-item').on('click', function () {
      if ($(this).hasClass('is-active')) {
        $(this).removeClass('is-active');
        $('.order__menu-top').removeClass('order__menu-top--hidescroll');
        $('body').removeClass('is-unscrollable');
      } else {
        $('.insure-item').removeClass('is-active');
        $('.order__menu-top').addClass('order__menu-top--hidescroll');
        $('body').addClass('is-unscrollable');
        $(this).addClass('is-active');
      }
    });
  }

  // otevírání insureItem na hover
  function insureItem() {
    $('.insure-item').hover(
      function () {
        //$('.insure-item').removeClass('is-active');
        //$(this).addClass('is-active');
      },
      function () {
        $('.insure-item').removeClass('is-active');
        $('.order__menu-top').removeClass('order__menu-top--hidescroll');
        $('body').removeClass('is-unscrollable');
      }
    );
  }

  // nastaveni pri scroll
  $('.order__menu-top').on('scroll', function () {
    orderMenu();
  });

  // modal okna
  if ($('.modal').length) {
    modal();
  }

  // shrnutí objednávky
  if ($('.summary').length) {
    summary();
  }

  //order progress
  if ($('#order-progress').length) {
    orderProgress();
  }

  // youtube video v modálním okně
  if ($('.js-video-start').length) {
    //new ModalVideo('.js-video-start', { channel: 'youtube' });
    $('.js-video-start').modalVideo({
      youtube: {
        controls: 1,
        autoplay: 1,
      },
    });
  }

  // scroll o 100% výšky okna při kliknutí
  if ($('.js-scroll').length) {
    $('.js-scroll').on('click', function (event) {
      event.preventDefault();
      $('html, body').animate(
        { scrollTop: window.scrollY + window.innerHeight },
        100
      );
    });
  }

  // galerie
  if ($('.gallery').length) {
    $('.gallery a').simpleLightbox({
      showCounter: false,
    });
  }

  // galerie glightbox
  if ($('.glightbox').length) {
    let lightbox = GLightbox();
  }

  // faq sekce
  if ($('.faq').length) {
    $('.faq__block-title').on('click', function () {
      if ($(this).parent().hasClass('is-open')) {
        $(this).next('.faq__block-answer').slideUp('fast');
        $(this).parent().removeClass('is-open');
      } else {
        $(this).next('.faq__block-answer').slideDown('fast');
        $(this).parent().addClass('is-open');
      }
    });
  }

  // faq stránka - často kladené otázky
  if ($('.faq-page').length) {
    faqPage();
  }

  // koktaktní stránka box
  if ($('.contact').length) {
    contact();
  }

  // objednávkový form krok 3
  if ($('.order-person-form').length) {
    cartOrderPersonCheckout();
  }

  // objednávkový form krok 1-2 cz
  if ($('.order-form-cz').length) {
    orderFormCz();
    cartOrderSubjectCheckout();
    obligatory();
    calculatePrice();
  }
  // objednávkový form krok 1-2 sk
  if ($('.order-form-sk').length) {
    orderFormCz();
    cartOrderSubjectCheckout();
    obligatory();
    calculatePrice();
  }

  // payment form krok 5
  if ($('.order-form-payment').length) {
    cartOrderPaymentCheckout();
    calculatePrice();
  }

  // payment form krok 5
  if ($('.order-payment').length) {
    paymentForm();
  }

  // thx page
  if ($('.thx').length) {
    thxPage();
  }
  // customer subjects
  if ($('.customer-subject-insurance').length) {
    customerSection();
  }

  //vocabulary page
  if ($('.vocabulary').length) {
    vocabularySection();
  }

  //vocabulary page
  if ($('.places-section').length) {
    placesSection();
  }

  // intro slider
  if ($('.intro-slider').length) {
    var time = 10;
    var $bar, $slick, isPause, tick, percentTime;

    $slick = $('.intro-slider__wrap');

    $slick.slick({
      lazyLoad: 'ondemand',
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      prevArrow: $('.js-intro-slider-prev'),
      nextArrow: $('.js-intro-slider-next'),
      adaptiveHeight: true,
      fade: true,
      speed: 2000,
    });

    $barRound = $('.intro-slider__progress-circle');

    $slick.on({
      mouseenter: function () {
        isPause = true;
      },
      mouseleave: function () {
        isPause = false;
      },
    });

    $slick.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      startProgressbar();
    });

    startProgressbar();
  }

  function startProgressbar() {
    resetProgressbar();
    percentTime = 0;
    isPause = false;
    tick = setInterval(interval, 10);
  }

  var $rbar = $('.intro-slider__progress-circle circle');
  var rlen = 2 * Math.PI * $rbar.attr('r');

  function interval() {
    percentTime += 1 / (time + 0.1);
    $rbar.css({
      'stroke-dasharray': rlen,
      'stroke-dashoffset': rlen * (1 - percentTime / 100),
    });

    if (percentTime >= 100) {
      $slick.slick('slickNext');
      startProgressbar();
    }
  }

  function resetProgressbar() {
    clearTimeout(tick);
  }

  // review slider
  if ($('.review__slider').length) {
    // funkce pro zajištění náhodného pořadí, zdroj: https://stackoverflow.com/questions/31459832/randomise-and-order-divs-slick-js
    $.fn.randomize = function (selector) {
      var $elems = selector ? $(this).find(selector) : $(this).children(),
        $parents = $elems.parent();

      $parents.each(function () {
        $(this)
          .children(selector)
          .sort(
            function (childA, childB) {
              // * Prevent last slide from being reordered
              if ($(childB).index() !== $(this).children(selector).length - 1) {
                return Math.round(Math.random()) - 0.5;
              }
            }.bind(this)
          )
          .detach()
          .appendTo(this);
      });

      return this;
    };

    $('.review__slider')
      .randomize()
      .slick({
        infinite: true,
        slidesToScroll: 1,
        slidesToShow: 3,
        dots: false,
        arrows: true,
        prevArrow: $('.js-review-control-prev'),
        nextArrow: $('.js-review-control-next'),
        fade: false,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 480,
            autoplay: false,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
  }

  // body kolo
  if ($('.points--1').length) {
    points1();
  }
  if ($('.points--2').length) {
    points2();
  }
  if ($('.points--3').length) {
    points3();
  }
  if ($('.points--4').length) {
    points4();
  }

  // tlačítko zobrazit/skrýt více informací o pojištění, zákaznická sekce
  if ($('.js-insurance-button-show-hide').length) {
    $('.js-insurance-button-show-hide').on('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if ($(this).closest('.insurance').hasClass('is-open')) {
        $(this).closest('.insurance').removeClass('is-open');
        $(this).parent().next('.insurance__inside').slideUp('fast');
        $(this).removeClass('is-active');
      } else {
        $(this).closest('.insurance').addClass('is-open');
        $(this).parent().next('.insurance__inside').slideDown('fast');
        $(this).addClass('is-active');
      }
    });
  }

  // zobrazit/skrýt více informací o pojištění, zákaznická sekce (kliknutí na celé overview)
  if ($('.js-insurance-show-hide').length) {
    $('.js-insurance-show-hide').on('click', function (event) {
      event.preventDefault();
      if ($(this).closest('.insurance').hasClass('is-open')) {
        $(this).closest('.insurance').removeClass('is-open');
        $(this).next('.insurance__inside').slideUp('fast');
        $(this).find('.js-insurance-button-show-hide').removeClass('is-active');
      } else {
        $(this).closest('.insurance').addClass('is-open');
        $(this).next('.insurance__inside').slideDown('fast');
        $(this).find('.js-insurance-button-show-hide').addClass('is-active');
      }
    });
  }

  // zobrazování badge po kliknutí na "i"
  if ($('.insurance__alert').length) {
    $('.insurance__alert').on('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      //alert('test');
      $(this).siblings('.insurance__alert-badge').toggleClass('is-active');
      $(document).on('click', function (e) {
        if (!$(e.target).hasClass('insurance__alert')) {
          $('.insurance__alert-badge').removeClass('is-active');
        }
      });
    });
  }

  if ($('.js-sticky-cta').length) {
    $(window).scroll(function () {
      var $cta = $('.js-sticky-cta');
      $scrollHeight = window.innerHeight / 2;
      if ($(window).scrollTop() > $scrollHeight) {
        $cta.addClass('is-visible');
      } else {
        $cta.removeClass('is-visible');
      }
    });
  }

  if ($('.header--intro').length) {
    $(window).scroll(function () {
      var $headerIntro = $('.header--intro');
      $scrollHeight = window.innerHeight;
      if ($(window).scrollTop() > $scrollHeight) {
        $headerIntro.addClass('header--intro-fixed');
      } else {
        $headerIntro.removeClass('header--intro-fixed');
      }
    });
  }

  // custom select přidání tabindex="0"
  // script pro rozhodnutí zda custom select zobrazit nahoře nebo klasicky dole
  if ($('.custom-select').length) {
    $('.select-selected').attr('tabIndex', 0);
    customSelectAbove();
  }

  //customer accident JS
  if ($('.customer-accident').length) {
    customerAccident();
    claimForm();
  }

  //obligatory JS
  if ($('.obligatory').length) {
    obligatory();
    calculatePrice();
  }

  //obligatory iframe
  if ($('.obligatory-iframe').length) {
    obligatory();
    calculateIframePrice();
  }

  // thxbox možnost zabalit a rozbalit
  if ($('.thx__box-headline').length) {
    $('.thx__box-headline').on('click', function () {
      if ($(this).closest('.thx__box').hasClass('is-collapsed')) {
        $(this).closest('.thx__box').removeClass('is-collapsed');
      } else {
        $(this).closest('.thx__box').addClass('is-collapsed');
      }
    });
  }

  // simplebar scrollbar pro Select2
  if ($('.select2').length) {
    $('select').on('select2:open', function () {
      var select2Dropdown = $('.select2-results__options').get(0);

      setTimeout(function () {
        new SimpleBar(select2Dropdown, {
          autoHide: false,
        });
      }, 0);
    });
  }

  // simplebar scrollbar pro form-label
  if ($('.form-label').length) {
    const formLabel = document.getElementsByClassName('form-label__agree');
    for (let i = 0; i < formLabel.length; i++) {
      new SimpleBar(formLabel[i], {
        autoHide: false,
      });
    }
  }

  // simplebar scrollbar pro summary content
  if ($('.summary').length) {
    const summaryContent = document.getElementsByClassName('summary__content');
    for (let i = 0; i < summaryContent.length; i++) {
      new SimpleBar(summaryContent[i], {
        autoHide: false,
      });
    }
  }
});
